// @flow
import React from 'react';
import { Tabs, Tab } from 'material-ui/Tabs';
import moment from 'moment';

import FlatButton from 'material-ui/FlatButton';
import IconPrev from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import IconNext from 'material-ui/svg-icons/hardware/keyboard-arrow-right';

import './dategrid.css';

moment.locale('ru');

type Props = {
    value: Object,
    onChange: Function,
}

type State = {
    current: any,
    days: Array<any>,
};

class DateGrid extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = this.stateForDate(this.props.value);
    }

    componentDidMount() {
        this.handleChangeTab(moment(this.props.value).format('YYYY-MM-DD'));
    }

    componentWillReceiveProps(nextProps: Props) {
        if (moment(nextProps.value).format('YYYY-MM-DD') !== moment(this.state.current).format('YYYY-MM-DD')) {
            this.setState(this.stateForDate(nextProps.value));
        }
    }

    stateForDate = (date: Date) => ({
        current: moment.utc(date).startOf('day'),
        days: [
            moment.utc(date).isoWeekday(1).startOf('day'),
            moment.utc(date).isoWeekday(2).startOf('day'),
            moment.utc(date).isoWeekday(3).startOf('day'),
            moment.utc(date).isoWeekday(4).startOf('day'),
            moment.utc(date).isoWeekday(5).startOf('day'),
            moment.utc(date).isoWeekday(6).startOf('day'),
            moment.utc(date).isoWeekday(7).startOf('day'),
        ],
    });

    dateChanged = (d: string) => {
        const date = moment(d).toDate();
        if (this.props.onChange) {
            this.props.onChange(date);
        }

        this.setState(this.stateForDate(date));
    };

    handleChangeTab = (value: string) => {
        const gridItem = document.querySelectorAll('.date-grid--item');
        for (let i = 0; i < gridItem.length; i += 1) {
            gridItem[i].classList.remove('is-active');
        }
        document.getElementsByClassName(`date-grid--item_${value}`)[0].classList.add('is-active');
    };

    previewWeek = () => {
        this.dateChanged(this.state.current.subtract(7, 'days'));
    };

    nextWeek = () => {
        this.dateChanged(this.state.current.add(7, 'days'));
    };

    render() {
        return (
            <section className="date-grid">
                <FlatButton
                    icon={<IconPrev />}
                    onClick={this.previewWeek}
                    className="date-grid--arrow"
                />
                <Tabs
                    style={{ flexGrow: '1' }}
                    tabItemContainerStyle={{
                        background: 'white',
                    }}
                    inkBarStyle={{
                        background: '#542376',
                        height: 3,
                        width: 36,
                        marginTop: -1,
                        marginLeft: 34,
                    }}
                    value={this.state.current.toISOString()}
                    onChange={this.dateChanged}
                >
                    {
                        this.state.days.map((day) => {
                            const formatDay = moment(day).format('YYYY-MM-DD');
                            return (
                                <Tab
                                    key={day.toISOString()}
                                    value={day.toISOString()}
                                    className={`date-grid--item date-grid--item_${formatDay}`}
                                    label={
                                        <div className="date-grid--label">
                                            <span className="date-grid--label-day">{day.format('dd')}</span>
                                            <span className="date-grid--label-time">{day.format('DD.MM')}</span>
                                        </div>
                                    }
                                />
                            );
                        })
                    }
                </Tabs>
                <FlatButton
                    icon={<IconNext />}
                    onClick={this.nextWeek}
                    className="date-grid--arrow"
                />
            </section>
        );
    }
}

export default DateGrid;



// WEBPACK FOOTER //
// src/components/controls/dategrid/DateGrid.js